module.exports = __webpack_public_path__ + "static/media/schlemmer2.831ab7cf.jpg";